import useTodoList from '../providers/todo_list/useTodoList';

const useAppMenu = () => {
  const { done, failed, loading, retry } = useTodoList();

  return { done, failed, loading, retry };
};

export default useAppMenu;
